import { Stack } from '@mui/material';

import { FormTextField } from '@/components/form/formTextField';

import type { IntegrationWizardState } from '../integrationWizardFlow';

interface AmazonEmrConfigurationProps {
  wizardState: IntegrationWizardState;
  setWizardState: (
    updater: (state: IntegrationWizardState) => IntegrationWizardState
  ) => void;
}

export const AmazonEmrConfiguration = ({
  wizardState,
  setWizardState,
}: AmazonEmrConfigurationProps) => {
  return (
    <Stack className='w-[582px]' gap='24px'>
      <FormTextField
        title='Account ID'
        placeholder='Example: 45763945834'
        value={wizardState.config?.emr?.accountId || ''}
        onChange={(event) =>
          setWizardState((state) => ({
            ...state,
            config: {
              ...state.config,
              emr: {
                accountId: event.target.value,
              },
            },
          }))
        }
      />
    </Stack>
  );
};
